import { useForm } from './Form';
import { classNames } from 'libs/react';
import { useEffect } from 'libs/react';
import { useState } from 'libs/react';
import { LanguageSelect } from 'components/form/private/LanguageSelect';
import { React } from 'libs/react';
import { FormRichTextInput } from './LazyFormRichTextInput';
import './TranslatableRichTextInput.scss';
import { useUser } from 'components/user/UserProvider';
/**
 * @component TranslatableRichTextInput
 * @since 1.0.0
 */
export function TranslatableRichTextInput(props) {
    /*
     * Note for future users:
     * This components needs to be wrapped inside a form to work properly
     * otherwise values will not be displayed correctly when selecting
     * a new language.
     */
    var _a;
    let { name, path, style, label, infos, error, required, optional, disabled, placeholder, languages, rows } = Object.assign({ style: 'normal' }, props);
    const form = useForm();
    const user = useUser();
    const [language, setLanguage] = useState(languages.indexOf(languages.filter((lang) => { var _a, _b; return lang.code === ((_b = (_a = user.user) === null || _a === void 0 ? void 0 : _a.language) === null || _b === void 0 ? void 0 : _b.code); })[0]));
    const [values, setValues] = useState(extract(name, (_a = props.defaultValues) !== null && _a !== void 0 ? _a : props.values));
    /**
     * @function getName
     * @since 1.0.0
     * @hidden
     */
    function getName(lang) {
        return path + '.' + lang + '.' + name;
    }
    /**
     * @function getValue
     * @since 1.0.0
     * @hidden
     */
    function getValue(lang) {
        return values && values[lang] && values[lang][name];
    }
    /**
     * @function getError
     * @since 1.0.0
     * @hidden
     */
    function getError(lang) {
        return form.getError(getName(lang));
    }
    /**
     * @function onBlur
     * @since 1.0.0
     * @hidden
     */
    function onBlur() {
        if (props.onBlur) {
            props.onBlur();
        }
    }
    /**
     * @function onFocus
     * @since 1.0.0
     * @hidden
     */
    function onFocus() {
        if (props.onFocus) {
            props.onFocus();
        }
    }
    /**
     * @function onLanguageValueChange
     * @since 1.0.0
     * @hidden
     */
    function onLanguageValueChange(langIndex, value) {
        setValues((prev) => {
            const next = [...prev];
            if (next[langIndex] == null) {
                next[langIndex] = {};
            }
            next[langIndex] = Object.assign(Object.assign({}, next[langIndex]), { [name]: value });
            return next;
        });
        if (props.onChange) {
            props.onChange(languages[langIndex], value);
        }
    }
    useEffect(() => {
        if (props.defaultValues) {
            setValues(extract(name, props.defaultValues));
        }
    }, [props.defaultValues]);
    useEffect(() => {
        if (!props.defaultValues && props.values) {
            setValues(extract(name, props.values));
        }
    }, [props.values]);
    useEffect(() => {
        /*
         * If we have an error in a specific language,
         * make sure we show the incorrect value in this
         * specific language.
         */
        for (let i = 0; i < languages.length; i++) {
            const error = getError(i);
            if (error) {
                setLanguage(i);
                break;
            }
        }
    });
    if (error == null) {
        error = getError(language);
    }
    const className = classNames('translatable-form-rich-text', 'translatable-form-rich-text--' + style, props.className);
    return (React.createElement("div", { className: className }, languages.map((lang, index) => {
        const value = getValue(index);
        if (error == null) {
            error = getError(index);
        }
        /**
         * Make sure we do not make an hidden field required because
         * the browser will try to show the required error but it will
         * be hidden by the container. Rely on server validation for
         * these types of error.
         */
        required = required && language == index;
        const className = classNames('translatable-form-rich-text-language', 'translatable-form-rich-text-language--' + style, {
            'translatable-form-rich-text-language--inactive': language != index
        });
        return (React.createElement("div", { key: lang.code, className: className },
            React.createElement(FormRichTextInput, { name: getName(index), style: style, label: label, infos: infos, value: !props.defaultValues ? value : undefined, defaultValue: props.defaultValues ? value : undefined, error: error, required: required, optional: optional, disabled: disabled, placeholder: placeholder, rows: rows, onBlur: onBlur, onFocus: onFocus, onChange: (newValue) => onLanguageValueChange(index, newValue), prefix: React.createElement(LanguageSelect, { current: languages[language], options: languages, onSelect: (language) => setLanguage(languages.indexOf(language)) }) })));
    })));
}
/**
 * @function extract
 * @since 1.0.0
 * @hidden
 */
function extract(name, values) {
    return values ? values.map((value) => ({ [name]: value[name] })) : [];
}
